import React, { useEffect, useState } from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Loader } from '../ui/loader';
import { CustomContainer } from '.'; // eslint-disable-line import/no-cycle
import { Gallery as ReactGallery } from '../ReactGridGallery';
import { checkImageURL, getUrls, parseImgurURL } from '../Utils';

interface GalleryProps {
  data?: string;
  urls?: string[];
}

const Gallery: React.FC<GalleryProps> = props => {
  const [urls, setUrls] = useState<string[]>([]);
  const [isChecking, setIsChecking] = useState<boolean>(true);

  useEffect(() => {
    const { data, urls } = props;

    if (Array.isArray(urls)) {
      setUrls(urls);
      setIsChecking(false);
    } else if (data) {
      const validURLS = getUrls(data)
        .map(url => parseImgurURL(url))
        .filter(url => checkImageURL(url));

      setUrls(validURLS);
      setIsChecking(false);
    } else {
      setIsChecking(false);
    }
  }, [props.data, props.urls]);

  if (!urls.length) {
    return null;
  }

  return (
    <CustomContainer>
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl">
            多媒體
          </CardTitle>
        </CardHeader>
        <CardContent className="relative">
          {isChecking && (
            <div className="absolute inset-0 bg-white/80 flex items-center justify-center z-10">
              <Loader />
            </div>
          )}
          <picture>
            <ReactGallery
              enableImageSelection={false}
              images={urls.map((url: string) => ({
                src: url,
                width: 1,
                height: 1,
              }))}
            />
          </picture>
        </CardContent>
      </Card>
    </CustomContainer>
  );
};

export default Gallery;
